import common from "../common";
import MiniSignal from "mini-signals";

export default class HealthBar extends PIXI.Container
{
    constructor(id, maxHealth, victories, direction = 1, colour = 0xfa2205)
    {
        super();

        this.id = id;
        this.maxHealth = maxHealth;
        this.health = maxHealth;
        this.bar = null;

        this.starMarkers = null;

        this.victories = victories;
        this.victoriesCounter = null;

        this.direction = direction;
        this.colour = colour;

        this.signals = {
            depleted: new MiniSignal()
        };

        this.init();
    }

    init()
    {
        //var backing = common.display.rectangle({fillColour:0xf2ea05, rectWidth:300, rectHeight:50, parent:this});
        //this.bar = common.display.rectangle({fillColour:this.colour, rectWidth:300, rectHeight:50, parent:this});
        
        this.bar = new PIXI.mesh.NineSlicePlane(P3.assets.texture('life_bar'), 0, 0, 50, 0);
        this.bar.width = 323;
        this.bar.tint = this.colour;
        this.bar.scale.x = this.direction;
        this.addChild(this.bar);

        var starPlacements = [{x:-100, y:70}, {x:0, y:-70}, {x:100, y:70}];

        if(this.id == 0)
        {
            this.starMarkers = [];
            for(var i in common.config.settings.gameFlow.starMarks)
            {
                var p = common.config.settings.gameFlow.starMarks[i];
                var starHolder = common.display.container({x:(this.bar.width * this.direction) * p, y:this.bar.height/2, scale:0.1, parent:this});
                starHolder.percentage = p;
                starHolder.stars = [];
                starHolder.active = false;
                for(var j = 0; j < 3; j++)
                {
                    starHolder.stars.push(common.display.sprite({asset:'star_' + (j <= (Number(i)-1) ? 'on' : 'off'), x:starPlacements[j].x, y:starPlacements[j].y, anchor:0.5, scale:0, parent:starHolder}));
                }
                this.starMarkers.push(starHolder);
            }

            this.setStarMarkers();
        }

        this.victoriesCounter = common.display.container({y:this.bar.height + 35, x:240 * this.direction, parent:this});

        this.setVictories(this.victories);
    }

    destroy()
    { 
        super.destroy();
    }

    hit(damage)
    {
        this.health = Math.max(0, this.health - damage);
        TweenMax.to(this.bar.scale, 0.2, {x:(this.health / this.maxHealth) * this.direction, ease:Sine.easeInOut});

        if(this.health <= 0)
        {
            this.signals.depleted.dispatch(this.id);
        }

        if(this.starMarkers)
        {
            this.setStarMarkers();
        }
    }

    setVictories(victories)
    {
        var lastVictories = this.victories;
        this.victories = victories;

        this.victoriesCounter.removeChildren();

        for(var i = 0; i < common.config.settings.gameFlow.rounds; i++)
        {
            var trophy = common.display.sprite({asset:'icon_trophy' + (i >= victories ? '_black' : ''), scale:0.5, x: (40 * i) * this.direction, anchor:0.5, parent:this.victoriesCounter});
            if(i < victories && i >= lastVictories)
            {
                TweenMax.to(trophy.scale, .3, {x:0.6, y:0.6, ease:Sine.easeInOut, startAt:{x:0.5, y:0.5}, repeat:1, yoyo:true});
            }
        }
    }

    setStarMarkers()
    {
        var loseTweenObj = {y:300, rotation:-30 * PIXI.DEG_TO_RAD, alpha:0, ease:Sine.easeIn};
        for(var i = this.starMarkers.length-1; i >= 0; i--)
        {
            if(this.health / this.maxHealth >= this.starMarkers[i].percentage)
            {
                var tl = new TimelineMax();

                if(i < this.starMarkers.length-1 && this.starMarkers[i+1].active)
                {
                    for(var j in this.starMarkers[i+1].stars)
                    {
                        tl.to(this.starMarkers[i+1].stars[j], .5, loseTweenObj, 0.2 * Number(j));
                    }
                    this.starMarkers[i+1].active = false;
                }

                if(!this.starMarkers[i].active)
                {
                    for(var j in this.starMarkers[i].stars)
                    {
                        tl.to(this.starMarkers[i].stars[j].scale, .2, {x:1, y:1, ease:Sine.easeOut});
                    }
                    this.starMarkers[i].active = true;
                }

                break;
            }
            else if(i == 0 && this.health / this.maxHealth < this.starMarkers[i].percentage && this.starMarkers[i].active)
            {
                var tl = new TimelineMax();
                for(var j in this.starMarkers[0].stars)
                {
                    tl.to(this.starMarkers[0].stars[j], .5, loseTweenObj, 0.2 * Number(j));
                }
                this.starMarkers[0].active = false;
            }
        }
    }

}